import Reveal from "@/components/Reveal";
import ProductGrid from "@/components/ProductGrid";

export default function Dupatta({ items, query }) {
  const q = (query || "").trim().toLowerCase();
  const filtered = q
    ? (items || []).filter((p) =>
        `${p.name} ${p.description || ""}`.toLowerCase().includes(q)
      )
    : items || [];
  const emptyHint = q
    ? `Keine Treffer für „${query.trim()}" — schreib uns per WhatsApp, was du suchst!`
    : "Neue Dupattas kommen bald — frag gerne per WhatsApp an.";

  return (
    <section
      id="dupatta"
      className="relative scroll-mt-24 py-24 md:py-32"
      data-testid="dupatta-section"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <Reveal className="mb-12 flex flex-col gap-6 md:mb-16 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-4 text-xs font-light uppercase tracking-[0.35em] text-gold">
              03 — Dupatta
            </p>
            <h2 className="font-serif text-5xl font-light tracking-[-0.02em] text-cream md:text-7xl">
              Dupatta <em className="text-goldgrad">&amp; Tücher</em>
            </h2>
          </div>
          <p className="max-w-xs text-sm font-light leading-relaxed text-rosy">
            Handbestickte Dupattas in allen Farben — das i-Tüpfelchen zu jedem Suit.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <ProductGrid items={filtered} testidPrefix="dupatta" emptyHint={emptyHint} />
        </Reveal>
      </div>
    </section>
  );
}
